export const alphaNumericRegex = /^[A-Za-z0-9]*$/;
export const nameCharactersRegex = /^[ A-Za-z'.-]*$/;
